import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Notification, NotificationsService as ToastService } from 'angular2-notifications';
import { AppNotification } from './app-notification.interface';

@Injectable()
export class NotificationService {
  constructor(private router: Router, private toastService: ToastService) { }

  addNotification = (notification: AppNotification): void => {
    const {
      title, message, type, timeOut,
    } = notification;
    const options = {
      timeOut,
      showProgressBar: false,
      pauseOnHover: true,
      clickToClose: true,
      animate: 'scale',
    };

    const toast: Notification = this[type](title, message, options);

    if (notification.routeParams) {
      if (!toast.click) return;
      toast.click.subscribe(() => this.router.navigate(notification.routeParams as string[]));
    }
  };

  private warning = (title: string, message: string, options: Record<string, unknown>)
    : Notification => this.toastService.warn(title, message, options);

  private success = (title: string, message: string, options: Record<string, unknown>)
    : Notification => this.toastService.success(title, message, options);

  private information = (title: string, message: string, options: Record<string, unknown>)
    : Notification => this.toastService.info(title, message, options);
}
